export enum HttpMethods {
  POST = 'post',
  GET = 'get',
  PUT = 'put',
  DELETE = 'delete',
}
